<template>
  <div class="relative box-progress">
    <div class="total-progress">
      <div class="progress" :style="`width: ${Math.round(this.progress)}%!important`"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props:['progress'],
 
  mounted(){
   
  },
  computed: {
    ...mapGetters("progress", ["GET_PROGRESS"]),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods:{
     


  }

};
</script>

<style scoped>
.progress {
  height: 6px;
  background: #e55974;
  border-radius: 10px;
  position: relative;
  z-index: 2;
}

.box-progress {
  width: 200px;
  padding-top: 0px;
}

.total-progress {
  background: #cccccc 0% 0% no-repeat padding-box;
  width: 200px;
  border-radius: 10px;
  position: relative;
}

.progress-text {
  font: normal normal bold 13px/22px Roboto;
}

.percent {
  font: normal normal bold 19px/23px Roboto;
  letter-spacing: 0px;
  padding-left: 50px;
}
</style>
